function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState } from 'react';
import Uppy from '@uppy/core';
import { Dashboard } from '@uppy/react';
import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import { useTranslation } from 'react-i18next';
const FileUploader = /*#__PURE__*/React.memo(_ref => {
  let {
    onSelectFile,
    setUppyInstance,
    onUserEditFileStart,
    onUserEditFileEnd,
    isAddingFilesDisabled
  } = _ref;
  const {
    t
  } = useTranslation();
  const [uppy, setUppy] = useState(null);
  const restrictions = {
    maxFileSize: 2 * 1024 * 1024 * 1024,
    allowedFileTypes: null
  };
  useEffect(() => {
    if (uppy && isAddingFilesDisabled) {
      const count = uppy.getFiles().length;
      uppy.setOptions({
        restrictions: _objectSpread(_objectSpread({}, restrictions), {}, {
          maxNumberOfFiles: count
        })
      });
    }
  }, [isAddingFilesDisabled, uppy]);
  useEffect(() => {
    const uppyInstance = new Uppy({
      restrictions,
      autoProceed: false,
      debug: false,
      allowMultipleUploads: true
    });
    uppyInstance.on('file-added', onSelectFile);
    uppyInstance.on('manual-progress-update', (file, percentage) => {
      const files = _objectSpread({}, uppyInstance.getState().files);
      if (!files[file.id]) return;
      files[file.id] = _objectSpread(_objectSpread({}, files[file.id]), {}, {
        progress: _objectSpread(_objectSpread({}, files[file.id].progress), {}, {
          uploadStarted: true,
          uploadComplete: false,
          percentage
        })
      });
      uppyInstance.setState({
        files
      });
    });
    uppyInstance.on('upload-success', (file, response) => {
      const files = _objectSpread({}, uppyInstance.getState().files);
      files[file.id] = _objectSpread(_objectSpread({}, files[file.id]), {}, {
        progress: {
          uploadComplete: true,
          percentage: 100
        }
      });
      uppyInstance.setState({
        files
      });
    });
    uppyInstance.on('upload-error', (file, error) => {
      const files = _objectSpread({}, uppyInstance.getState().files);
      if (files[file.id]) files[file.id].error = error.message || 'Upload error';
      uppyInstance.setState({
        files
      });
    });
    uppyInstance.on('complete', result => {
      console.info('All uploads complete. Successful:', result.successful.map(f => f.name), 'Failed:', result.failed.map(f => f.name));
    });
    uppyInstance.on('dashboard:file-edit-start', onUserEditFileStart);
    uppyInstance.on('dashboard:file-edit-complete', onUserEditFileEnd);
    uppyInstance.on('file-meta-updated', file => {
      const newName = file.meta.name;
      if (newName && newName !== file.name) {
        uppyInstance.setFileState(file.id, {
          name: newName
        });
      }
    });
    setUppy(uppyInstance);
    if (setUppyInstance) setUppyInstance(uppyInstance);
    return () => {
      uppyInstance.cancelAll();
    };
  }, [onSelectFile, onUserEditFileStart, onUserEditFileEnd, setUppyInstance]);
  if (!uppy) return null;
  return /*#__PURE__*/React.createElement(Dashboard, {
    uppy: uppy,
    proudlyDisplayPoweredByUppy: false,
    showProgressDetails: true,
    hideUploadButton: true,
    width: "100%",
    height: "400px",
    theme: "auto",
    metaFields: [{
      id: 'name',
      name: t('name'),
      placeholder: t('Enter file name')
    }]
  });
});
export default FileUploader;